<div class="row">
    
    <div class="col-lg-12 col-xs-12">
    
        <section widget class="widget">

            <header>
                <h4>
                    <i class="fa fa-filter color-blue"></i>&nbsp;&nbsp;
                    <b>{{ 'Filters' | translate |uppercase }}</b>
                </h4>
            </header>

            <div class="widget-body">

                <div class="row">

                    <div class="col-md-12">

                        <div class="form-group row filters filter-form bg-light-grey">
                            <div class="col-lg-2 col-xs-12" *ngIf="allOrders">
                                <select class="form-control select2" [(ngModel)]="searchFields.country"
                                    placeholder="works" (ngModelChange)="getAllRestaurants()">
                                    <option id="1" value="" disabled> {{ 'Country' | translate }} </option>
                                    <option value=""> {{ 'SelectedAll' | translate }} </option>
                                    <option value="CO">
                                        Colombia
                                    </option>
                                    <option value="US">
                                        {{'USA' | translate}}
                                    </option>
                                </select>
                            </div>

                            <div class="col-lg-2 col-xs-12" *ngIf="status !== statusConstants.PENDING">
                                <select class="form-control select2" [(ngModel)]="searchFields.statusOrder"
                                    (ngModelChange)="getAllRestaurants()">
                                    <option id="1" value="" disabled> {{ 'Status' | translate }} </option>
                                    <option value=""> {{ 'SelectedAll' | translate }} </option>
                                    <option *ngFor="let orderStatus of ordersStatus" [ngValue]="orderStatus.number">
                                        {{orderStatus.name | translate }}</option>
                                </select>
                            </div>

                            <div class="col-lg-2 col-xs-12" *ngIf="allOrders">
                                <select class="form-control select2" [(ngModel)]="searchFields.restaurantId"
                                    placeholder="works">
                                    <option id="1" value="" disabled> {{ 'Restaurant' | translate }} </option>
                                    <option value=""> {{ 'SelectedAll' | translate }} </option>
                                    <option *ngFor="let restaurant of restaurants" [ngValue]="restaurant.restaurantId">
                                        {{ restaurant.restaurantName}}
                                    </option>
                                </select>
                            </div>

                            <div class="col-lg-2 col-xs-12">
                                <div class="input-group">
                                    <input type="text" [(ngModel)]="searchFields.orderCodeParam" #searchInput
                                        class="form-control" id="inputSearch"
                                        placeholder="{{ 'FIELDS_TO_FIND_ORDERS' | translate }}">
                                </div>
                            </div>

                            <div class="col-lg-2 col-xs-12">
                                <div class="input-group">
                                    <input class="form-control" placeholder="{{ 'DATE_RANGE' | translate }}" bsDaterangepicker
                                    #dpr="bsDaterangepicker" [(ngModel)]="searchFields.dateRangePicker" [bsConfig]="{
                                    dateInputFormat: 'DD/MM/YYYY', containerClass: 'theme-green' }">
                                </div>
                            </div>

                            <div class="col-lg-1 col-xs-12">
                                <button [disabled]="buttonStatus" class="btn btn-success mb-xs" (click)="getOrders()">
                                    <b>{{ 'Search' | translate |uppercase }}</b>
                                </button>
                            </div>

                            <div class="text-right col-lg-2 col-xs-12">
                                <button (click)="openModalInfo()" [disabled]="buttonStatus" class="btn btn-warning mb-xs">
                                    <em class="fa fa-info-circle"></em>
                                </button>
                            </div>
                        </div>

                        <br>

                    </div>

                </div>

            </div>

            <div bsModal #pushErrorModal="bs-modal" class="modal fade modal-push" tabindex="-1" role="dialog"
                aria-labelledby="mySmallModalLabel" aria-hidden="true"
                [config]="{ backdrop: false, ignoreBackdropClick: true, keyboard: false}">
                <div class="modal-dialog modal-md">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-xs-center fw-bold mt" id="myModalLabel18">
                                {{ 'WE_ARE_SORRY' | translate}}
                            </h4>
                            <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <span> {{'PUSH_ERROR' | translate}}</span>
                            <div class="col-md-12 flex">
                                <button id="saveSeasonBtn" class="btn btn-success width-50"
                                    (click)="goToDetailOrder()">{{ 'SEE_ORDER' | translate }} </button>
                                <button id="saveSeasonBtn" class="btn btn-danger width-50"
                                    (click)="closeModal()">{{ 'Close' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-responsive">

                <div class="form-group row mt-3 mb-3 d-flex">

					<div class="col-lg-12 col-md-12 col-sm-12 d-flex">

                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <ul class="nav nav-tabs nav-pagination text-center" id="myTab" role="tablist">
                                <li class="nav-item" *ngFor="let page of paginationArray">
                                    <a (click)="getOrders(null, page)"  [ngClass]="{'active': page === itemsPerPageSelected}" class="nav-link" id="items10" data-toggle="tab" role="tab" aria-controls="basic" aria-expanded="true">{{page}}</a>
                                    <div class="lds-dual-ring" *ngIf="paginationSelected == page"></div>
                                </li>
                            </ul>
                        </div>

                        <div class="col-lg-6 col-md-6 text-xs-left">
                            
                            <button class="btn btn-primary mb-xs pull-right mr-3" (click)="refreshOrders()">
                                <em class="fa fa-refresh"></em> {{ 'REFRESH' | translate }}
                            </button>
                            

                            <button class="btn btn-success mb-xs pull-right" (click)="exportToExcel()" [disabled]="downloadExcel" [hidden]="downloadExcel">
                                <i class="fa fa-file-text"></i> {{ 'EXPORT_TO_EXCEL' | translate }}
                            </button>


                            <button class="btn btn-gray flx pull-right" [hidden]="!downloadExcel" [disabled]="!downloadExcel">
                                {{ 'processing' | translate }}&nbsp;
                                <div class="lds-ellipsis">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </button>
        
                        </div>

                    </div>

				</div>

                
                <table class="table table-striped" id="table-restaurant">
                    <caption></caption>
                
                    <thead class="thead-table-bg-dark">
                        <tr>
                            <th id="number" *ngIf="!status">
                                <a>#
                                    <b class="{{orderIconObject}}"></b>
                                </a>
                            </th>

                            <th id="number">
                                <a>Codigo
                                    <b class="{{orderIconObject}}"></b>
                                </a>
                            </th>
                            <th id="date">
                                <a>{{ 'Date' | translate }}
                                    <b class="{{orderIconObject}}"></b>
                                </a>
                            </th>

                            <th id="type">
                                <a>{{ 'Type' | translate }}
                                    <b class="{{orderIconObject}}"></b>
                                </a>
                            </th>
                            <th id="customer">
                                <a>{{ 'CUSTOMER' | translate }}
                                    <b class="{{orderIconObject}}"></b>
                                </a>
                            </th>

                            <th id="status" class="text-center" *ngIf="!status">
                                <a>{{ 'Status' | translate }}
                                    <b class="{{orderIconObject}}"></b>
                                </a>
                            </th>

                            <th id="brand">
                                <a> {{'BRAND' | translate}} </a>
                            </th>

                            <th id="restaurant" class="text-center" *ngIf="allOrders">
                                <a>{{ 'Restaurant' | translate }}
                                    <b class="{{orderIconObject}}"></b>
                                </a>
                            </th>

                            <!-- <th id="table">
                            <a>{{ 'TABLE' | translate }}
                                <em class="{{orderIconObject}}"></em>
                            </a>
                            </th> -->
                                                <!-- <th id="server">
                            <a>{{ 'SERVER' | translate }}
                                <em class="{{orderIconObject}}"></em>
                            </a>
                            </th> -->

                            <th>
                                <a><b>Pago</b></a>
                            </th>

                            <th id="total">
                                <a>{{ 'TOTAL' | translate }}
                                    <b class="{{orderIconObject}}"></b>
                                </a>
                            </th>

                            <th id="actions" class="txtcntr">{{ 'Actions' | translate }}</th>
                        </tr>
                    </thead>

                    <ng-container *ngFor="let order of orders">

                        <tbody class="load-background-order-{{order.omtStatus}}">

                            <tr>

                                <td *ngIf="!status">
                                    <b>{{order.orderConsecutive}} </b>
                                </td>

                                <td>
                                    <b>{{order.orderCode}}</b>
                                </td>

                                <td>
                                    <b>{{order.orderCreation | dateTimeLocalize | async}}</b>
                                </td>

                                <td>

                                    <ng-container *ngIf="order.ordOrderType === orderTypeConstants.dineIn">
                                        <b class="color-blue">{{ "DINE_IN" | translate|uppercase }}</b>
                                    </ng-container>

                                    <ng-container *ngIf="order.ordOrderType === orderTypeConstants.counter">
                                        <b class="color-blue">{{ "COUNTER" | translate|uppercase }}</b>
                                    </ng-container>
                                    
                                    <ng-container
                                        *ngIf="order.ordOrderType === orderTypeConstants.phoneOrder && order.orderPhoneType == 1">
                                        <b class="color-blue">{{ "PICKUP" | translate|uppercase }}</b>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="order.ordOrderType === orderTypeConstants.phoneOrder&& order.orderPhoneType == 2">
                                        <b class="color-blue">{{ "DELIVERY" | translate|uppercase }}</b>
                                    </ng-container>

                                    <ng-container *ngIf="order.ordOrderType === orderTypeConstants.phoneOrder && (order.orderPhoneType ===
                                        phoneOrderTypeConstants.table || order.orderPhoneType === phoneOrderTypeConstants.turn ||
                                        order.orderPhoneType === phoneOrderTypeConstants.turnAutomatic)">
                                        <b class="color-blue">{{ "DINE_IN" | translate|uppercase }}</b>
                                    </ng-container>

                                    <ng-container *ngIf="order.ordOrderType === orderTypeConstants.barTab">
                                        <b class="color-blue">{{ "BAR_TAB" | translate|uppercase }}</b>
                                    </ng-container>

                                    <ng-container *ngIf="order.ordOrderType === orderTypeConstants.driveThru">
                                        <b class="color-blue">{{ "DRIVE_THRU" | translate|uppercase }}</b>
                                    </ng-container>

                                    <ng-container *ngIf="order.dineInTurn">
                                        <span
                                            *ngIf="order.ordDineInType === DINE_IN_CONSTANTS.TABLE">{{'TABLE' | translate|uppercase }}:</span>
                                        <span
                                            *ngIf="order.ordDineInType === DINE_IN_CONSTANTS.BEACON">{{'BEACON' | translate|uppercase }}:</span>
                                        <span>{{order.dineInTurn}}</span>
                                    </ng-container>

                                    <br>

                                    <ng-container *ngIf="order.ordStatus == 5">
                                        <b class="label-deferred-order">
                                            {{"Deferred"|translate | uppercase }}
                                        </b>
                                    </ng-container>

                                </td>

                                <td>
                                    <b>{{order.clientName}} {{order.clientLastName}}</b>
                                </td>

                                <td *ngIf="!status">

                                    <ng-container
                                        *ngIf="order.omtStatus === statusConstants.PENDING || order.omtStatus == 1">
                                        <b>{{ "PENDING" | translate | uppercase }}</b>
                                    </ng-container>

                                    <ng-container *ngIf="order.omtStatus === statusConstants.RECEIVED">
                                        <b>{{ "RECEIVED" | translate }}</b>
                                    </ng-container>

                                    <ng-container *ngIf="order.omtStatus === statusConstants.BEING_PREPARED">
                                        <b>{{ "BEING_PREPARED" | translate }}</b>
                                    </ng-container>

                                    <ng-container *ngIf="order.omtStatus === statusConstants.PREPARED">
                                        <b>{{ "PREPARED" | translate }}</b>
                                    </ng-container>

                                    <ng-container *ngIf="order.omtStatus === statusConstants.DELIVERED">
                                        <b>{{ "DELIVERED" | translate }}</b>
                                    </ng-container>

                                    <ng-container *ngIf="order.omtStatus === statusConstants.CANCELED">
                                        <b>{{ "CANCELED" | translate }}</b>
                                    </ng-container>

                                </td>

                                <td>
                                    <ng-container *ngIf="order.orderBrandFrom === types_brand.TYPE_KIND_OMT_WEB">
                                        <b>{{ "Online OMT"|uppercase }}</b>
                                    </ng-container>

                                    <ng-container *ngIf="order.orderBrandFrom === types_brand.TYPE_KIND_OMT_APP">
                                        <b>{{"APP OMT"|uppercase }}</b>
                                    </ng-container>

                                    <ng-container *ngIf="order.orderBrandFrom === types_brand.TYPE_KIND_MENU_ONLINE">
                                        <b>{{"ONLINE"|uppercase }}</b>
                                    </ng-container>

                                    <ng-container *ngIf="order.orderBrandFrom === types_brand.TYPE_KIND_WHITE_LABEL">
                                        <b>{{"APP"|uppercase }}</b>
                                    </ng-container>

                                </td>

                                <td *ngIf="allOrders">
                                    <b>{{ order.restaurantName }}</b>
                                </td>

                                <td>
                                    <span *ngIf="order.uponDelivery == 0">
                                        <b>{{ "credit_card" | translate| uppercase}}</b>
                                    </span>

                                    <span *ngIf="order.uponDelivery == 1">
                                        <b>{{ "UPON_DELIVERY" | translate | uppercase}} </b>
                                        <span *ngIf="isColombia">
                                            <b> - {{order.ordPayMethod | translate | uppercase}}</b>
                                        </span>
                                    </span>

                                </td>

                                <td class="text-align-right">
                                    <b>{{ order.invTotal | currency:'USD':true:'1.2-2' }}</b>
                                </td>

                                <td class="width-250 actions" id="ractions-{{order.id}}">
                                    <div class="">
                                        
                                        <button class="btn btn-secondary  mb-xs" role="button"
                                            title="{{ 'ShowDetails' | translate }}" (click)="goToDetailOrder(order)">
                                            <em class="fa fa-eye text-info"></em>
                                        </button>

                                        <button
                                            *ngIf="order.omtStatus === statusConstants.PENDING || order.omtStatus === statusConstants.PENDING_ALSO"
                                            class="btn btn-info" role="button" title="Retry"
                                            (click)="getDataFromOrderToSync(order)"
                                            [disabled]="order.resendingOrderSyncStatus">
                                            <em class="fa fa-paper-plane" *ngIf="!order.resendingOrderSyncStatus"></em>
                                            <app-loading-image *ngIf="order.resendingOrderSyncStatus"
                                                [classCSS]="'order-list'">
                                            </app-loading-image>
                                        </button>

                                        <button
                                        *ngIf="order.omtStatus === statusConstants.PENDING || order.omtStatus === statusConstants.PENDING_ALSO"
                                        class="btn btn-primary" role="button" title="RetryAndroid"
                                        (click)="getDataFromOrderToSync(order, true)"
                                        [disabled]="order.resendingOrderAndroidSyncStatus">
                                            <em class="fa fa-mobile" *ngIf="!order.resendingOrderAndroidSyncStatus"></em>
                                            <app-loading-image *ngIf="order.resendingOrderAndroidSyncStatus"
                                                [classCSS]="'order-list'">
                                            </app-loading-image>
                                        </button>

                                        <button
                                            *ngIf="order.omtStatus !== statusConstants.DELIVERED && order.omtStatus !== statusConstants.CANCELED"
                                            class="btn btn-danger" role="button" title="Delete"
                                            (click)="cancelOrder(order)">
                                            <em class="fa fa-ban" ></em>
                                        </button>
        
                                    </div>
                                </td>
                            </tr>

                        </tbody>

                    </ng-container>

                </table>

            </div>

            <div *ngIf="orders">
                <div *ngIf="orders.length <=0">
                    <div class="alert alert-info alert-dismissable">
                        <strong>{{'NoDataToShow' | translate }}</strong>
                    </div>
                </div>
            </div>

            <!-- Botones Paginación -->
            <div class="form-group row" *ngIf="pagination && pagination.totalItems > 0">
                <div class="col-lg-12 col-md-12 d-flex justify-content-center">
                    <label>{{ 'Page' | translate }} {{pagination.currentPage}}</label>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12 col-12 pagNew d-flex justify-content-center">
                    <pagination class="pagination pagination-md justify-content-end active"
                        [totalItems]="pagination.totalItems" [maxSize]="maxSize.maxSizePagination"
                        [itemsPerPage]="pagination.itemsPerPage" [lastText]="lastPag" [firstText]="firstPag"
                        [previousText]="prevPag" [nextText]="nextPag" (pageChanged)="getOrders($event)"
                        [boundaryLinks]="true" [rotate]="true">
                    </pagination>
                </div>

            </div>

        </section>

    </div>

</div>
